import { parseAppDate } from '@macs-frontend/core/utils/date';
import { FormGroupState, setErrors, updateGroup, validate } from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';
import { GeneralInfoForm } from '../../manage-project-shared/reducers/general-info.reducer';

export const validateAndUpdateGeneralInfoForm = (
  generalInfoForm: FormGroupState<GeneralInfoForm>,
): FormGroupState<GeneralInfoForm> => {
  const endDate = generalInfoForm.value.endDate;
  const startDate = generalInfoForm.value.startDate;

  const isValid =
    !endDate || !startDate || +parseAppDate(startDate) <= +parseAppDate(endDate);

  const errors = isValid ? {} : { dates: true };

  return updateGroup<GeneralInfoForm>({
    startDate: setErrors(errors),
    endDate: setErrors(errors),
    contactIds: validate(required),
    projectGroupId: validate(required),
  })(generalInfoForm);
};
